(function () {

    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.iframeblock = window.oneadvanced.iframeblock || {};
    window.oneadvanced.iframeblock.init = function () {
        //console.log("initialising iframeblock...");

        // get all of the iframeBlocks on the page
        var iframeBlocks = document.querySelectorAll('[data-iframe-id]');

        iframeBlocks.forEach(function (iframe) {
            var cssSelector = "#" + iframe.id;
            iFrameResize({
                heightCalculationMethod: "documentElementOffset",
                warningTimeout: 10000
            }, cssSelector);
        });
    };
    window.oneadvanced.iframeblock.hasLoaded = true;
})();